$( document ).ready( function($) {
	var newd = new Date();
	if( getCookie("time") < newd.getTime() )
	{
		deleteCookie("time");
	}
	timeOff	= function(event)
	{
		if( $(".shop-btn").length > 0 )
		{
			window.location.href = $(".shop-btn").attr("redirect");
		}
		if( $(".previewbar").size() > 0 )
		{
			window.location.href = $(".previewbar").attr("link");
		}
	}
	fun_countdown	= function()
	{
		cookie_time	= new Date();
		cookie_time.setTime(getCookie("time"));
		$('.time_left').countdown({until: cookie_time, format: "MS", onExpiry: timeOff, padZeroes: true});
		previewbar	= $(".previewbar");
		if(previewbar.length > 0)
		{
			previewbar.show();
			pos	= previewbar.position().top;
			out	= previewbar.outerHeight();
			if(pos < 100)
			{
				$("body").css({ marginTop: out+'px' });
			} else {
				$("body").css({ marginBottom: out+'px' });
			}
		}
		window_resize() ;
	}
	window_resize	= function()
	{
		if( $( ".coupon-for-another" ).width() < 560 )
		{
			$( ".coupon_responsive" ).hide() ;
			$( ".coupon_image" ).show() ;
		} else {
			$( ".coupon_image" ).hide() ;
			$( ".coupon_responsive" ).show() ;
		}
	}
	window_load	= function( time )
	{
		if(getCookie("time") == "")
		{
			newDate = new Date();
			newDate.setMinutes(newDate.getMinutes() + time);
			newtime = newDate.getTime() ;
			setCookie("time", newtime , newtime);
		}
		newYear = getCookie("time");
		href_url	= $(".href_url").attr("href");
		product	= "" ;
		if( products )
		{
			product	= "&products=" + products.join(",") ;
		}
		$( ".href_url" ).attr( "href" , href_url + "?db=" + Number( newYear ) + product );
		$(".coupon-for-another").show();
		fun_countdown();
	}
	currentHref = window.location.href;
	ct = currentHref.split('?db=');
	if (ct.length > 1)
	{
		extime = parseInt(ct[1],10);
		newYear = new Date(extime);
		if(new Date() < newYear)
		{
			setCookie("time", extime, extime);
		}
	}
	if( getCookie("time") != "" )
	{
		get_url = getUrlVars() ;
		try {
			fun_previewbar() ;
		} catch(err) {
		}
		$(".previewbar").click(function(){
			window.location.href = $(".previewbar").attr("href");
		});
	}
} ) ;
console.log( document.cookie ) ;
getUrlVars	= function ()
{
	vars = {} ;
	url	= window.location.href ;
	if( url.indexOf('?') >= 0 )
	{
		hashes = url.slice(url.indexOf('?') + 1).split('&');
		for( i = 0 ; i < hashes.length ; i++ )
		{
			hash = hashes[i].split('=');
			vars[hash[0]] = hash[1];
		}
	}
	return vars;
}
function setCookie(cname, cvalue, exdays)
{
	var d = new Date();
	d.setTime( exdays );
	var expires = "expires="+ d.toUTCString();
	document.cookie = cname + "=" + encodeURI(cvalue) + ";" + expires + ";path=/";
}
function getCookie(cname)
{
	var name = cname + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(';');
	for(var i = 0; i <ca.length; i++)
	{
		var c = ca[i];
		while (c.charAt(0) == ' ')
		{
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0)
		{
			return c.substring(name.length, c.length);
		}
	}
	return "";
}
function deleteCookie(cname) {
    document.cookie = cname + "=deleted; expires=" + new Date(0).toUTCString();
}
$( window ).resize(function() {
	window_resize() ;
});